export default "__VITE_ASSET__8bbfd311__"